<template>
  <div class="element-wrapper">
    <div class="row">
      <div class="col">
        <h6 class="element-header">Serviço: {{servico}}</h6>
        <div class="row">
          <div class="col">
            <table class="table table-lightborder">
              <thead>
                <tr>
                  <th class="text-center">Descrição do exame</th>
                  <th class="text-center">Particular</th>
                  <th class="text-center">Dr.Achei</th>
                  <th class="text-center">Dr.Achei Card</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="exame in exames" :key="exame._id">
                  <td>{{exame.nomeExame}}</td>
                  <td class="text-center">{{exame.valorParticular || 0.0 | money}}</td>
                  <td class="text-center">{{(exame.valorDrAchei || 0.0) | money}}</td>
                  <td class="text-center">{{exame.valorSinSaude || 0.0 | money}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="text-right">
                    <b>Total:</b>
                  </td>
                  <td class="text-center">
                    <b>{{subTotalParticular | money}}</b>
                  </td>
                  <td class="text-center">
                    <b>{{subTotalDrAchei | money}}</b>
                  </td>
                  <td class="text-center">
                    <b style="color: #24b314">{{subTotalSinSaude | money}}</b>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h6 class="element-header">Escolha como quer pagar:</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-6" v-if="rede.pagamentoOnline">
            <a style="cursor: pointer" class="post-box" @click="tipoPagamento = 'Drachei'" :class="{'bg-light': tipoPagamento === 'Drachei'}">
              <div class="post-media"><img src="@/img/brand-drachei-vert.svg" class="img-fluid" alt="Brand"></div>
              <div class="post-content">
                <div class="label">Dr.Achei <div class="trending down">
                  </div>
                </div>
                <h4 class="post-title">
                  {{parseFloat(subTotalDrAchei||0.0, 10) | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})}}
                </h4>
                <div class="post-foot">
                  
                  <a class="post-link" href="#"><span>Selecionar</span></a>
                </div>
              </div>
            </a>
          </div>
          <div class="col-6">
            <a style="cursor: pointer" class="post-box" @click="tipoPagamento = 'SinSaude'" :class="{'bg-light': tipoPagamento === 'SinSaude'}">
              <div class="post-media">
                <img src="@/img/drachei-card.png" alt="Sin Saúde" class="img-fluid mt-3">
              </div>
              <div class="post-content">
                <div class="label">Dr.Achei Card <div v-if="porcentagemDesconto" class="trending down">
                    <span>{{parseFloat(porcentagemDesconto, 10).toFixed(2)}}%</span><i class="os-icon os-icon-arrow-down"></i>
                  </div></div>
                <h4 class="post-title">
                  {{parseFloat(subTotalSinSaude, 10) | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})}}
                </h4>
                <div class="post-foot">
                  <a class="post-link" href="#"><span>Selecionar</span></a>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col">
              <button :disabled="disableBtnPagamento()" @click="finalizar()" class="btn btn-lg btn-primary text-right">Ir para Pagamento</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from '@/event-bus'

export default {
  mounted () {
    eventBus.$on('loginSuccess', this.finalizaAfterLogin)
  },
  computed: {
    servico () {
      return this.$store.getters.servico
    },
    exames () {
      return this.$store.getters.exames
    },
    rede () {
      return this.$store.getters.redeSingle
    },
    porcentagemDesconto () {
      return this.exames ? this.exames[0].porcentagemDesconto : 0
    },
    subTotalParticular () {
      return this.$store.getters.subTotalParticular
    },
    subTotalDrAchei () {
      return this.$store.getters.subTotalDrAchei
    },
    subTotalSinSaude () {
      return this.$store.getters.subTotalSinSaude
    }
  },

  data () {
    return {
      tipoPagamento: '',
      totalAPagar: 0
    }
  },
  watch: {
    tipoPagamento (newValue) {
      switch (newValue) {
        case 'Drachei':
          this.totalAPagar = this.subTotalDrAchei
          break
        case 'SinSaude':
          this.totalAPagar = this.subTotalSinSaude
          break
        default:
          this.totalAPagar = 0
      }
    }
  },
  methods: {
    disableBtnPagamento () {
      return !this.tipoPagamento
    },
    finalizaAfterLogin () {
      if (!this.$store.getters.user.cartao && this.tipoPagamento === 'SinSaude') {
        this.$router.push({name: 'SinSaudeCard'})
        return false
      }
      this.$store.dispatch('savePedidoFromCache')
        .then((pedido) => {
          this.$router.push({name: 'Checkout', query: {id: pedido._id}})
        })
    },
    finalizar () {
      let pedido = {
        unidade: this.rede,
        exames: this.exames,
        tipoPedido: this.servico,
        tipoPagamento: this.tipoPagamento,
        valorTotal: this.totalAPagar,
        desconto: this.subTotalParticular - this.totalAPagar
      }

      if (!this.$store.getters.user) {
        this.$store.dispatch('storePedido', pedido)
          .then(() => eventBus.$emit('openModal', 'login'))
        return false
      }

      if (!this.$store.getters.user.cartao && this.tipoPagamento === 'SinSaude') {
        this.$router.push({name: 'SinSaudeCard'})
        return false
      }

      pedido.cliente = this.$store.getters.user.id
      this.$store.dispatch('savePedido', pedido)
        .then(pedido => {
          // redirecionar pro checkout
          this.$router.push({name: 'Checkout', query: {id: pedido._id}})
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/single-consultorio/ServicesExameTab.vue